// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VoiceCall.css */
.voice-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%; /* Sesuaikan dengan container parent */
  min-height: 400px;
  background: #1a1a1a;
  color: white;
  padding: 20px;
  border-radius: 15px;
  position: relative;
  overflow: hidden;
}
.voice-back-btn {
  position: absolute;
  top: 18px;
  left: 18px;
  border: 1px solid #444;
  border-radius: 999px;
  padding: 8px 14px;
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}

/* Avatar Container */
.avatar-wrapper {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.avatar-circle {
  width: 140px;
  height: 140px;
  background: #333;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  z-index: 10;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* STATES */

/* 1. LISTENING (Merah) */
.listening .avatar-circle {
  background: #ff4757;
  transform: scale(1.1);
  box-shadow: 0 0 60px rgba(255, 71, 87, 0.4);
}
.listening .ripple {
  animation: ripple 1.5s infinite linear;
  border-color: rgba(255, 71, 87, 0.5);
}

/* 2. PROCESSING (Kuning - Loading) */
.processing .avatar-circle {
  background: #ffa502;
  transform: scale(0.9);
  animation: breathe 2s infinite ease-in-out;
}
.processing .loading-ring {
  opacity: 1;
  animation: spin 1.5s infinite linear;
}

/* 3. SPEAKING (Hijau) */
.speaking .avatar-circle {
  background: #2ed573;
  transform: scale(1.15);
  box-shadow: 0 0 50px rgba(46, 213, 115, 0.5);
}

/* Animations */
.ripple {
  position: absolute;
  border-radius: 50%;
  border: 3px solid transparent;
  width: 100%;
  height: 100%;
  top: 0; left: 0;
  opacity: 0;
  z-index: 1;
}

.loading-ring {
  position: absolute;
  width: 190px;
  height: 190px;
  border: 4px solid transparent;
  border-top: 4px solid #ffa502;
  border-right: 4px solid #ffa502;
  border-radius: 50%;
  z-index: 5;
  opacity: 0;
  transition: opacity 0.3s;
}

@keyframes spin { 100% { transform: rotate(360deg); } }
@keyframes ripple { 0% { transform: scale(0.7); opacity: 1; } 100% { transform: scale(1.8); opacity: 0; } }
@keyframes breathe { 0% { box-shadow: 0 0 20px rgba(255, 165, 2, 0.2); } 50% { box-shadow: 0 0 50px rgba(255, 165, 2, 0.6); } 100% { box-shadow: 0 0 20px rgba(255, 165, 2, 0.2); } }

/* UI Text */
.status-text { font-size: 20px; font-weight: 600; margin-bottom: 5px; }
.sub-status { font-size: 14px; color: #aaa; margin-bottom: 20px; }

.start-btn {
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 50px;
  border: none;
  background: linear-gradient(45deg, #2ed573, #1e90ff);
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(46, 213, 115, 0.4);
  transition: transform 0.2s;
}
.start-btn:active { transform: scale(0.95); }
.stop-btn {
  background: linear-gradient(45deg, #f44336, #d32f2f);
  box-shadow: 0 4px 15px rgba(211, 47, 47, 0.4);
}

.chat-log {
  margin-top: 20px;
  font-size: 12px;
  color: #888;
  max-width: 80%;
  text-align: center;
  max-height: 100px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/VoiceCall.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAE,sCAAsC;EACpD,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,uCAAuC;EACvC,4DAA4D;AAC9D;;AAEA,WAAW;;AAEX,yBAAyB;AACzB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,MAAM,EAAE,OAAO;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,wBAAwB;AAC1B;;AAEA,kBAAkB,OAAO,yBAAyB,EAAE,EAAE;AACtD,oBAAoB,KAAK,qBAAqB,EAAE,UAAU,EAAE,EAAE,OAAO,qBAAqB,EAAE,UAAU,EAAE,EAAE;AAC1G,qBAAqB,KAAK,2CAA2C,EAAE,EAAE,MAAM,2CAA2C,EAAE,EAAE,OAAO,2CAA2C,EAAE,EAAE;;AAEpL,YAAY;AACZ,eAAe,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACtE,cAAc,eAAe,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAEjE;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,oDAAoD;EACpD,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,0BAA0B;AAC5B;AACA,oBAAoB,sBAAsB,EAAE;AAC5C;EACE,oDAAoD;EACpD,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* VoiceCall.css */\r\n.voice-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%; /* Sesuaikan dengan container parent */\r\n  min-height: 400px;\r\n  background: #1a1a1a;\r\n  color: white;\r\n  padding: 20px;\r\n  border-radius: 15px;\r\n  position: relative;\r\n  overflow: hidden;\n}\n.voice-back-btn {\n  position: absolute;\n  top: 18px;\n  left: 18px;\n  border: 1px solid #444;\n  border-radius: 999px;\n  padding: 8px 14px;\n  background: rgba(255, 255, 255, 0.06);\n  color: #fff;\n  font-size: 12px;\n  cursor: pointer;\n}\n\r\n/* Avatar Container */\r\n.avatar-wrapper {\r\n  position: relative;\r\n  width: 200px;\r\n  height: 200px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.avatar-circle {\r\n  width: 140px;\r\n  height: 140px;\r\n  background: #333;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 60px;\r\n  z-index: 10;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.5);\r\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n}\r\n\r\n/* STATES */\r\n\r\n/* 1. LISTENING (Merah) */\r\n.listening .avatar-circle {\r\n  background: #ff4757;\r\n  transform: scale(1.1);\r\n  box-shadow: 0 0 60px rgba(255, 71, 87, 0.4);\r\n}\r\n.listening .ripple {\r\n  animation: ripple 1.5s infinite linear;\r\n  border-color: rgba(255, 71, 87, 0.5);\r\n}\r\n\r\n/* 2. PROCESSING (Kuning - Loading) */\r\n.processing .avatar-circle {\r\n  background: #ffa502;\r\n  transform: scale(0.9);\r\n  animation: breathe 2s infinite ease-in-out;\r\n}\r\n.processing .loading-ring {\r\n  opacity: 1;\r\n  animation: spin 1.5s infinite linear;\r\n}\r\n\r\n/* 3. SPEAKING (Hijau) */\r\n.speaking .avatar-circle {\r\n  background: #2ed573;\r\n  transform: scale(1.15);\r\n  box-shadow: 0 0 50px rgba(46, 213, 115, 0.5);\r\n}\r\n\r\n/* Animations */\r\n.ripple {\r\n  position: absolute;\r\n  border-radius: 50%;\r\n  border: 3px solid transparent;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0; left: 0;\r\n  opacity: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.loading-ring {\r\n  position: absolute;\r\n  width: 190px;\r\n  height: 190px;\r\n  border: 4px solid transparent;\r\n  border-top: 4px solid #ffa502;\r\n  border-right: 4px solid #ffa502;\r\n  border-radius: 50%;\r\n  z-index: 5;\r\n  opacity: 0;\r\n  transition: opacity 0.3s;\r\n}\r\n\r\n@keyframes spin { 100% { transform: rotate(360deg); } }\r\n@keyframes ripple { 0% { transform: scale(0.7); opacity: 1; } 100% { transform: scale(1.8); opacity: 0; } }\r\n@keyframes breathe { 0% { box-shadow: 0 0 20px rgba(255, 165, 2, 0.2); } 50% { box-shadow: 0 0 50px rgba(255, 165, 2, 0.6); } 100% { box-shadow: 0 0 20px rgba(255, 165, 2, 0.2); } }\r\n\r\n/* UI Text */\r\n.status-text { font-size: 20px; font-weight: 600; margin-bottom: 5px; }\r\n.sub-status { font-size: 14px; color: #aaa; margin-bottom: 20px; }\r\n\r\n.start-btn {\r\n  padding: 12px 30px;\r\n  font-size: 16px;\r\n  border-radius: 50px;\r\n  border: none;\r\n  background: linear-gradient(45deg, #2ed573, #1e90ff);\r\n  color: white;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 15px rgba(46, 213, 115, 0.4);\r\n  transition: transform 0.2s;\r\n}\r\n.start-btn:active { transform: scale(0.95); }\n.stop-btn {\n  background: linear-gradient(45deg, #f44336, #d32f2f);\n  box-shadow: 0 4px 15px rgba(211, 47, 47, 0.4);\n}\n\r\n.chat-log {\r\n  margin-top: 20px;\r\n  font-size: 12px;\r\n  color: #888;\r\n  max-width: 80%;\r\n  text-align: center;\r\n  max-height: 100px;\r\n  overflow-y: auto;\r\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
